import { Route } from 'react-router-dom';
import Page from './../../components/Page';
import Teams from './Teams';
import Team from './Team';
import Player from './Player';
import NewTeam from './NewTeam';
import NewPlayer from './NewPlayer';
import NewStaffMember from './NewStaffMember';
import Paths from '../../constants/paths';
import ErrorMessages from '../../components/ErrorMessages.js';
import { observer } from 'mobx-react-lite';
import StaffMember from './StaffMember';

const TeamsTab = ({ store }) => {
    return (
        <Page loading={!store.dataLoaded}>
            <div style={{ marginLeft: '2.5%' }}>
                <ErrorMessages messages={store.error} />
            </div>
            <Route exact path={Paths.TEAMS}>
                <Teams store={store} />
            </Route>
            <Route exact path={Paths.TEAM}>
                <Team store={store} />
            </Route>
            <Route exact path={Paths.TEAM_PLAYER}>
                <Player store={store} />
            </Route>
            <Route exact path={Paths.NEW_TEAM}>
                <NewTeam store={store} />
            </Route>
            <Route exact path={Paths.TEAM_NEW_PLAYER}>
                <NewPlayer store={store} />
            </Route>
            <Route exact path={Paths.NEW_STAFF_MEMBER}>
                <NewStaffMember store={store} />
            </Route>
            <Route exact path={Paths.STAFF_MEMBER}>
                <StaffMember store={store} />
            </Route>
        </Page>
    );
};

export default observer(TeamsTab);
